import React, { createContext, useEffect, useRef, useCallback } from 'react';

/**
 * KeyboardContext stores a single "current handler".
 * A handler is an object with one method: onKey(event) → boolean
 * Returning true means the handler consumed the key.
 */
export const KeyboardCtx = createContext(() => {});

/* Provider listens to keydown on window and forwards to the handler */
export function KeyboardProvider({ children }) {
  const handlerRef = useRef(null);

  const register = useCallback(handler => {
    handlerRef.current = handler;
  }, []);

  useEffect(() => {
    function listener(e) {
      const h = handlerRef.current;
      if (h && typeof h.onKey === 'function' && h.onKey(e)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, []);

  return (
    <KeyboardCtx.Provider value={register}>{children}</KeyboardCtx.Provider>
  );
}
